/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
const Yup = require('yup')
import { get } from 'lodash'
/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import AgreedTable from './components/AgreedTable'
import UnspecifiedTable from './components/UnspecifiedTable'
import { Alert } from '../../../common/Alert/Alert'
// import ToolTip from '../../../common/ToolTip/ToolTip'
import PopUp from '../../../common/PopUp/PopUp'
import { saveAs } from 'file-saver'
import CSVReader from 'react-csv-reader'

/**
 *     Import
 *     - CSS
 */
import '../styles/Step03.css'

/**
 * Step03 class {/quote/:id/step03}
 *
 * @class Step03FormHTML
 * @extends {React.Component<any, any>}
 */
let UploadCsv: any = null
const handleForce = data => {
    UploadCsv = data
}
let dirtyValue: any = false
let MtaunspecifiedItems: any = false

class Step03FormHTML extends React.Component<any, any> {

    /**
     * Creates an instance of Step03FormHTML.
     *
     * @param {*} props
     * @memberof Step03FormHTML
     */
    loadTimeOut: any = null
    CsvTitle: any = ''
    constructor(props: any) {
        super(props)

        let agreed = [{
            type: 'fineWinesAndSpirits',
            text: 'Wine & Spirit – Bottles',
            items: this.props.editQuote &&
                get(this.props, 'data.agreedItems.fine_wines_and_spirits') ?
                this.props.data.agreedItems.fine_wines_and_spirits : [],
            apiName: 'fine_wines_and_spirits',
        }]

        let unspecified = [{
            type: 'fineWinesAndSpirits',
            text: 'Wine & Spirit – Bottles',
            marketValue: this.props.editQuote &&
                get(this.props, 'data.unspecifiedItems.fine_wines_and_spirits') ?
                this.props.data.unspecifiedItems.fine_wines_and_spirits.toString() : '0',
            sumInsured: this.props.editQuote &&
                get(this.props, 'data.unspecifiedItems.fine_wines_and_spirits') ?
                this.props.data.unspecifiedItems.fine_wines_and_spirits : 0,
            apiName: 'fine_wines_and_spirits',
        }]
        agreed.push({
            type: 'collectiblesMemorabilia',
            text: 'Wine & Spirit – Casks',
            items: this.props.editQuote &&
                get(this.props, 'data.agreedItems.collectibles_memorabilia') ?
                this.props.data.agreedItems.collectibles_memorabilia : [],
            apiName: 'collectibles_memorabilia',
        })
        unspecified.push({
            type: 'collectiblesMemorabilia',
            text: 'Wine & Spirit – Casks',
            marketValue: this.props.editQuote &&
                get(this.props, 'data.unspecifiedItems.collectibles_memorabilia') ?
                this.props.data.unspecifiedItems.collectibles_memorabilia.toString() : '0',
            sumInsured: this.props.editQuote &&
                get(this.props, 'data.unspecifiedItems.collectibles_memorabilia') ?
                this.props.data.unspecifiedItems.collectibles_memorabilia : 0,
            apiName: 'collectibles_memorabilia',
        })

        this.state = {
            agreedOrUnspecified: true,
            totalAgreedValue: 0,
            totalUnspecifiedValue: 0,
            totalCollectionValue: 0,
            uploadAgreed: false,
            // MtaunspecifiedItems: false,
            // showAgreed: false,
            agreedItems: [...agreed],
            unspecifiedItems: [...unspecified],
        }
    }

    componentDidUpdate(prevProps: Readonly<any>, nextProps: any) {
        const {
            values,
        } = this.props

        if (prevProps.values.quoteId !== values.quoteId && values.quoteId) {

            let agreedItems = this.state.agreedItems
            if (Object.values(values.agIt).length) {
                for (const [left, right] of Object.entries(values.agIt)) {
                    let aindex = agreedItems.findIndex(a => a.apiName === left)
                    if (aindex !== -1) {
                        let arr: any[] = []
                        Object.values(right).map((ai) => {
                            let sarr: any = {
                                title: ai.title,
                                insured: ai.insured,
                                agreed_value: ai.agreed_value,
                            }
                            arr.push(sarr)
                        })
                        let items = 'items'
                        agreedItems[aindex][items] = arr
                    }
                }
            }
            this._updateAgreedItems(agreedItems)

            this.loadTimeOut = setTimeout(
                () => {
                    let unspecifiedItems = this.state.unspecifiedItems
                    if (Object.values(values.usIt).length) {
                        for (const [left, right] of Object.entries(values.usIt)) {
                            let uindex = unspecifiedItems.findIndex(u => u.apiName === left)
                            if (uindex !== -1) {
                                let sumInsured = 'sumInsured'
                                let marketValue = 'marketValue'
                                unspecifiedItems[uindex][sumInsured] = right
                                unspecifiedItems[uindex][marketValue] = right
                            }
                        }
                    }
                    this._updateUnspecifiedItems(unspecifiedItems)
                },
                300
            )
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step03FormHTML
     */
    componentWillUnmount() {
        clearTimeout(this.loadTimeOut)
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    /**
     * Update the values for Formik and the state when
     * changing data in the child component {TableContent}
     *
     * @param {*} agreedItems the new tableItems to update with
     * @memberof Step03FormHTML
     */
    _updateAgreedItems = (agreedItems: any) => {
        // Update Formik values
        this.props.setValues({ ...this.props.values, agreedItems })
        this.setState({ agreedItems })
        if (this.props.mta || this.props.editQuote) {
            dirtyValue = true
            // getUnspecifiedItems = get(this.props, 'data.unspecifiedItems')
        }

    }

    _updateUnspecifiedItems = (unspecifiedItems: any) => {
        // Update Formik values
        this.props.setValues({ ...this.props.values, unspecifiedItems })

        this.setState({ unspecifiedItems })
        if (this.props.mta || this.props.editQuote) {
            dirtyValue = true
            if (this.props.mta) {
                MtaunspecifiedItems = true
            }

            // getAgreedItems = get(this.props, 'data.agreedItems')
        }
    }

    /**
     * Calculates the result of the
     * Total sales/costs and Sum insured columns
     *
     * @param {String} type type of the column to calculate: insured or stock
     * @memberof Step03FormHTML
     */
    _calculateSum = (type) => {
        let total = 0

        if (type === 'agreed' || type === 'total') {
            this.state.agreedItems.map((agreedType) => {
                agreedType.items.map((item) => {
                    total += parseFloat(item.insured)
                })
            })
        }

        if (type === 'unspecified' || type === 'total') {
            this.state.unspecifiedItems.map((item) => {
                total += parseFloat(item.sumInsured)
            })
        }

        this.props.values.totalCollectionValue = Number(total).toFixed(2)
        // return Number(total).toFixed(2)
        return Number(total)
    }

    /**
     *
     */
    _changeAgreedUnspecified = () => {
        this.setState({ agreedOrUnspecified: !this.state.agreedOrUnspecified })
    }

    csvDownload = () => {
        this.CsvTitle = 'category,description,value' + '\n' +
            'Wine & Spirit – Bottles,test,0.00' + '\n' +
            'Wine & Spirit – Casks,test,0.00'
        let filename = 'Agreed Items.csv'
        const contentType = 'application/octet-stream'
        const blobSold = new Blob([this.CsvTitle], { type: contentType })
        saveAs(blobSold, filename)
    }

    okAgreedItem = () => {
        this.setState({
            uploadAgreed: false,
            // showAgreed: false
        })
        let agreedItems = this.state.agreedItems
        var pushItem: any = UploadCsv.map((item, i) => {
            if (
                item[0] && item[1] && item[2] &&
                ((item[0] || '').toLowerCase()) !== 'category' &&
                ((item[1] || '').toLowerCase()) !== 'description' &&
                (((item[2]) || '') !== 'value' && Number(item[2]) !== 0)
            ) {
                return {
                    category: item[0],
                    title: item[1],
                    insured: Number(item[2]),
                    agreed_value: item[2],
                }
            }
            return 0
        })
        const filteredItems = pushItem.filter(item => item !== 0)
        this.state.agreedItems.map((item, i) => {
            filteredItems.map((fItem, j) => {
                if (item.text === fItem.category) {
                    delete filteredItems[j].category
                    this.state.agreedItems[i].items.push(filteredItems[j])
                }
            })
        })
        this._updateAgreedItems(agreedItems)
    }

    AgreedItem = () => {
        this.setState({ uploadAgreed: true })
    }

    cancelAgreedItem = () => {
        this.setState({ uploadAgreed: false })
        UploadCsv = []
    }

    moveBack = () => {
        const {
            values,
        } = this.props

        this.props.history.push(`/quote/${values.quoteId}/step02`)
    }

    render() {

        const {
            handleSubmit,
            quote,
            isWineSpiritsSteve,
        } = this.props
        let errorList: any[] = []

        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        /**
         * Check if at least one item have been filled
         */
        let atLeastOneItem = (
            this._calculateSum('total') !== 0
        ) ? false : true

        if (quote.step03.done && !this.props.editQuote) {
            this.props.history.push('/quote/' + this.props.match.params.id + '/step04')
        }

        if (this.props.updateDirty) {
            this.props.dirty ? this.props.updateDirty(true) : this.props.updateDirty(false)
        }

        return (
            <div className="step03">
                {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
                    Object.keys(this.props.errors).filter(
                        (msg) => Object.keys(this.props.touched).includes(msg)
                    ).map((error, idx) => {
                        const msg = this.props.errors[error]
                        errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                    })
                )}

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                {(quote.step03.error) ? (
                    <Alert type="error">
                        Error: something went wrong please contact support
                    </Alert>
                ) : null}

                {
                    (this.state.uploadAgreed) ?
                        <PopUp
                            title="Agreed Items"
                            buttonText="Ok"
                            action={this.okAgreedItem}
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={this.cancelAgreedItem}
                        >
                            <CSVReader
                                cssClass="react-csv-input AgreedUpload"
                                label="Select CSV Agreed Item File"
                                onFileLoaded={handleForce}
                            />
                        </ PopUp>
                        :
                        null
                }
                <form className="step03Form" onSubmit={handleSubmit}>
                    <div>
                        <div className="inline__group">
                            <div className="inline__items shadow">
                                <div className="inline__item title">Wine & Spirits sum insured</div>
                                {/* <div className="inline__icon">
                                    <ToolTip position="left">
                                        Art & Antique dealers record stock they own based on either total cost or total
                                        selling price.  They then usually apply an uplift or a reduction to define their
                                        expected retail price and hence sum insured.  Begin by selecting cost price or
                                        selling price depending on how the client records stock. Next enter the total
                                        values before using the settlement basis slider to achieve a total sum insured
                                        in line with your client’s business practice (this is the figure that will
                                        appear on the schedule and will be the maximum the insured can claim).
                                    </ToolTip>
                                </div> */}
                            </div>
                        </div>
                        <div className="inline__group">
                            <div className={`inline__buttons center ${(this.props.mta ? 'disabled' : '')}`}>
                                <div
                                    className={'inline__item button__switch ' +
                                        (this.state.agreedOrUnspecified ? 'selected' : '')}
                                    onClick={() => { this._changeAgreedUnspecified() }}
                                >Agreed Value
                                </div>
                                <div
                                    className={'inline__item button__switch ' +
                                        (!this.state.agreedOrUnspecified ? 'selected' : '')}
                                    onClick={() => { this._changeAgreedUnspecified() }}
                                >Unspecified
                                </div>
                            </div>
                            {(this.state.agreedOrUnspecified ?
                                <div className="agreed_upload">
                                    <p>Fill the details below or use template to quickly fill a CSV</p>
                                    {/* href="../../../../src/images/AgreedItem.csv" download */}
                                    <a className="agreeDownloadBtn" onClick={this.csvDownload}>
                                        {/* <span> */}
                                        Download CSV Template
                                        {/* </span> */}
                                    </a>
                                    <a onClick={() => this.AgreedItem()}>
                                        <span>
                                            Upload CSV
                                        </span>
                                    </a>
                                </div> :
                                null
                            )}
                        </div>
                        {this.state.agreedOrUnspecified ?
                            <AgreedTable
                                tableItems={this.state.agreedItems}
                                updateParentStateItems={this._updateAgreedItems}
                                isWineSpiritsSteve={isWineSpiritsSteve}
                            />
                            :
                            <UnspecifiedTable
                                tableItems={this.state.unspecifiedItems}
                                updateParentStateItems={this._updateUnspecifiedItems}
                                isWineSpiritsSteve={isWineSpiritsSteve}
                            />
                        }
                        <div className="values__group">
                            <div className={`values__item values__item--left ${(this.props.mta ? 'disabled' : '')}`}>
                                <div className="values__item--left__text">
                                    <div className="values__item--left__text__inline">
                                        Total agreed value
                                        <h3>{this._calculateSum('agreed').toLocaleString('en-GB', {
                                            style: 'currency',
                                            currency: 'GBP',
                                        })}</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="values__item values__item--right">
                                <div>
                                    Total unspecified value
                                    <h3>{this._calculateSum('unspecified').toLocaleString('en-GB', {
                                        style: 'currency',
                                        currency: 'GBP',
                                    })}</h3>
                                </div>
                                <div>
                                    Total Wine & Spirits value
                                    <h3 className="col_value">{this._calculateSum('total').toLocaleString('en-GB', {
                                        style: 'currency',
                                        currency: 'GBP',
                                    })}</h3>
                                </div>
                            </div>
                        </div>

                        {(this.props.editQuote) ? (
                            (dirtyValue) ?
                                <div className="quote__form__group quote__form__group--update">
                                    <Button
                                        type="submit"
                                    >
                                        Update
                                    </Button>
                                </div> : null
                        ) : null}
                    </div>
                    <div className="quote__form__group quote__form__group--submit collector-submit-wrapper">
                        <Button
                            half={true}
                            type="button"
                            onClick={this.moveBack}
                        >
                            Back
                        </Button>
                        <Button
                            type="submit"
                            half={true}
                            onClick={() => window.scrollTo(0, 0)}
                            disabled={atLeastOneItem}
                        >
                            Save and continue
                        </Button>
                    </div>
                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const Step03Form = withFormik<any, any>({
    enableReinitialize: true,
    mapPropsToValues: (props: any) => {
        if (props.mta) {
            return {
                agreedItems: [],
                unspecifiedItems: [],
                totalCollectionValue: Number(0),
                quoteId: get(props, 'match.params.id', ''),
                agIt: get(props, 'data.agreedItems', {}),
                usIt: get(props, 'data.unspecifiedItems', {}),
            }
        }
        return {
            agreedItems: [],
            unspecifiedItems: [],
            totalCollectionValue: Number(0),
            quoteId: get(props, 'fullQuote.id', ''),
            agIt: get(props, 'fullQuote.stockBusinessAssets.agreedItems', {}),
            usIt: get(props, 'fullQuote.stockBusinessAssets.unspecifiedItems', {}),
        }
    },

    validationSchema: Yup.object().shape({
        totalCollectionValue: Yup.number()
            .min(2500, 'The Collection sum insured value can\'t be less than £2500'),
    }),

    handleSubmit: (values, { props, setSubmitting, resetForm }) => {
        let content: any
        if (props.mta) {
            content = {
                'quote': {
                    'id': props.match.params.id,
                    'stockBusinessAssets': {
                        'agreedItems': Object.assign(
                            {},
                            ...values.agreedItems.map(el => ({ [el.type]: el.items }))),
                        'unspecifiedItems': (MtaunspecifiedItems) ?
                            Object.assign(
                                {},
                                ...values.unspecifiedItems.map(el => ({ [el.type]: el.sumInsured }))) :
                            get(props, 'data.unspecifiedItems', {}),
                    },
                },
            }
        } else {
            content = {
                'quote': {
                    'id': props.editRenewal ? props.renewalQuoteId : props.match.params.id,
                    'stockBusinessAssets': {
                        'agreedItems': Object.assign(
                            {},
                            ...values.agreedItems.map(el => ({ [el.type]: el.items }))),
                        'unspecifiedItems': Object.assign(
                            {},
                            ...values.unspecifiedItems.map(el => ({ [el.type]: el.sumInsured }))),
                    },
                },
            }
        }

        if (props.mta) {
            props.updateData(content)
            dirtyValue = false
        } else {
            if (props.editRenewal) {
                dirtyValue = false
                props.setStep03Renewals(content).finally(() => {
                    props.step03Update()
                    props.getRenewalVariation(props.renewalQuoteId)
                })
            } else {
                props.setStep03(content)
                props.getQuoteVariation(props.match.params.id)
            }
        }
        resetForm(content)

        if (props.editQuote) {
            setTimeout(props.update, 500)
            dirtyValue = false
        }
    },

})(Step03FormHTML)
dirtyValue = false
export default Step03Form



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step03w/Step03w.tsx